//import * as base from 'utils/bolt/dynamicData.js';
export * from 'utils/bolt/dynamicData.js';
import Store from 'store/store';

export function transformPageData(data) {
	const appData = Store.get().appData;

	const youtubeMatch = data.hero?.youtube?.match(/[&?]v=([^&#]+)|youtu\.be\/([^?&#]+)|^([a-z0-9_-]+)$/i);
	const youtubeId = youtubeMatch?.[1] || youtubeMatch?.[2] || youtubeMatch?.[3];

	const boundingRegions = data.watch?.boundingRegions?.split?.(',').map(r => r.trim()).filter(r => r) || [];

	return [
		{
			base: 'bolt',
			id: data.url,
			data: [
				{
					id: 'filmHero',
					component: 'heroSpot',
					data: {
						background: {
							alt: data.hero?.alt,
							desktop: data.hero?.img,
							mobile: data.hero?.mobileImg
						},
						buttons: (data.hero?.buttons?.length
							? data.hero.buttons.map((button, i) => ({ label: button?.label, link: !i && data.watch?.showShowtimes ? `${data.url}-showtimes` : button?.link }))
							: [
								data.synopsis?.content && { label: 'Learn More', link: '#synopsis' },
								(data.watch?.showHomeEnt || data.watch?.showShowtimes) && { label: data.watch?.showShowtimes ? 'Now Showing' : 'Order Now', link: '#watch' }
							]
						).filter(button => button?.label),
						description: data.hero?.description,
						hasGradient: true,
						title: data.hero?.title,
						trailer: !youtubeId ? undefined : {
							trailer: {
								name: '',
								thumbSrc: `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
								youtubeId: youtubeId
							}
						}
					},
				},
				data.synopsis?.content && {
					id: 'filmSynopsis',
					component: 'synopsis',
					data: {
						hash: 'synopsis',
						content: data.synopsis?.content,
						credits: data.synopsis?.credits?.map(e => ({ heading: e?.title, names: e?.content?.replace(/(^[^ ]|.[^ ]|[^ ].)\n/gm, '$1  \n') })).filter(e => e.names),
					},
				},
				data.promo && {
					id: 'promoBanner',
					component: 'toutVertical',
					data: {
						hash: 'promo',
						title: data.promo.title,
						description: data.promo.description,
						button: data.promo.button,
						path: data.promo.link,
						img: data.promo.img,
						alt: data.promo.alt,
					},
				},
			].filter(e => e),
			type: 'filmPage',
			path: '/events/' + data.url + '/',
			group: data.group,
			customPageComponent: 'events',
			customHeaderLogo: data.customHeaderLogo,
			customFooterLogo: data.customFooterLogo,
		},
		data.watch?.showShowtimes && {
			id: `${data.url}-showtimes`,
			type: 'showtimes',
			path: `/events/${data.url}/tickets/`,
			data: {
				...appData?.pages?.boltShowtimes?.data,
				movieId: data.watch.movieId,
				boundingRegions: Object.fromEntries(boundingRegions.map(r => [r, true])),
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet } },
			},
		}
	].filter(e => e);
}